<template>
    <div class="gh-form" v-loading.fullscreen.lock="isProcessing" :element-loading-text="loadingText">
        <div class="gh-form__wrapper">
            <a ref="download"></a>
            <transition name="el-fade-in">
                <div v-show="hasError"
                     v-html="errorMessage"
                     class="gh-form__response is-error">
                </div>
            </transition>

            <el-form
                    :model="form"
                    :rules="form.validationRules"
                    @keyup.enter.native="attemptSubmit('elForm')"
                    ref="elForm"
                    class="gh-form__content">
                <!-- Profile -->
                <div class="gh-form__group">
                    <el-form-item prop="event">
                        <label class="gh-form__label">{{ label }}</label>
                        <el-select v-model="form.event" placeholder="Select one...">
                            <el-option
                                    v-for="event in invoicableEvents"
                                    :key="event.slug"
                                    :label="event.label"
                                    :value="event.slug">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </div>

                <div class="gh-form__group">
                    <el-form-item prop="email">
                        <label class="gh-form__label">Email Address*</label>
                        <el-input v-model="form.email" type="email" name="email"></el-input>
                    </el-form-item>
                </div>

                <!-- Actions -->
                <div class="gh-form__actions">
                    <el-button class="gh-button gh-button--cta" @click="attemptSubmit('elForm')"
                               :disabled="form.processing">
                        {{ computedSubmitButtonLabel }}
                    </el-button>
                </div>
            </el-form>
        </div>
    </div>
</template>

<script>
    import formMixin from '../mixins/form';

    export default {
        mixins: [formMixin],

        data() {
            return {
                submitButtonLabel: 'DOWNLOAD RECEIPT'
            }
        },

        computed: {
            label() {
                return this.eventType === 'live-course'
                    ? 'Select Course*'
                    : 'Select Event*'
            },

            invoicableEvents() {
                return this.events.filter(event => {
                    return event.invoiceDownloadable
                })
            },

            loadingText() {
                return `Retrieving Your Tax Invoice...`;
            },

            errorMessage() {
                const message = {
                    not_found_attendee: `We couldn't find that email address! Please check your spelling or try an alternative email.`,
                    no_payment_record: `Our records indicate that you did not have an invoice for this event.`,
                    registered_as_premium_member: `Your Mental Health Academy membership fee tax invoice is available via the "My Invoices" section of your MHA member profile. Please <a href="/login" style="color: #fff; text-decoration: underline">login here</a> to access it.`
                }[this.error.message];

                return message || 'Unable to retrieve your invoice';
            }
        },

        methods: {
            handleSubmit() {
                this.$store.dispatch('eventDocument/generateInvoice', this.formPayload)
                    .then(url => {
                        this.form.processing = false;
                        this.reset();

                        window.location.href = url;
                    })
                    .catch(_ => this.form.processing = false);
            }
        },
    }
</script>

<style lang="scss" scoped>
    .gh-form {
        max-width: 480px;
    }

    .gh-form__response {
        margin-bottom: 2rem;
    }
</style>
